import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { getAccountSubscriptionUsage, type SubscriptionUsage } from '../api';
import type { Account } from '../model';

import { useAccountQuery } from './useAccountQuery';

export function useAccountSubscriptionUsage(account: Account | null | undefined) {
  return useAccountQuery<SubscriptionUsage | null, RequestError>(
    account ? queryKeys.accounts.subscriptionUsage(account._id) : ['accounts', 'subscription-usage', null],
    ({ signal }) =>
      account ? observableToPromise(getAccountSubscriptionUsage(account), signal) : Promise.resolve(null),
    account,
  );
}
